import { EmptyPayload } from "@/lib/events/types";
import { Step } from "../steps/v2/step";
import { AvatarMediaError } from "./avatarManager";

export type AvatarManagerEvents = {
  mediaTimeUpdated: number;
  stepReplayed: Step;
  stepSkipped: Step;
  expandClicked: EmptyPayload;
  mediaFinished: EmptyPayload;
  mediaPlayTriggered: EmptyPayload;
  mediaPlayed: EmptyPayload;
  mediaPaused: EmptyPayload;
  mediaPauseTriggered: EmptyPayload;
  mediaTrackerInitialized: EmptyPayload;
  skipClicked: EmptyPayload;
  dismissClicked: EmptyPayload;
  mediaSeeked: { seekedTo: number };
  currentSectionSet: EmptyPayload;
  captionClicked: { status: boolean };
  muteClicked: { status: boolean };
  minimizeClicked: EmptyPayload;
  playClicked: EmptyPayload;
  pauseClicked: EmptyPayload;
  replayClicked: EmptyPayload;
  mediaError: AvatarMediaError;
};

export type AvatarEventContext = {
  time: number;
  sectionIndex: number;
  avatarStatus: string;
};

export const AvatarNamespace = "avatar" as const;
